jQuery(document).ready(function ($) {

	$.fn.isInViewport = function(buffer = 20) {
		if ($(this).data('visibilityBuffer')) {
			buffer = $(this).data('visibilityBuffer');
		}
		let elementTop = $(this).offset().top;
		let elementBottom = elementTop + $(this).outerHeight();
		let viewportTop = $(window).scrollTop();
		let viewportBottom = viewportTop + $(window).height();
		return elementTop + buffer < viewportBottom;
		//return elementBottom - buffer > viewportTop && elementTop + buffer < viewportBottom;
	};
	
	//SHOW HIDE MENU ON SCROLL
	let siteHeader = $('.site-header');
	
	function ScrollShowHide() {
		//CHECK SCROLLING STATUS. HIDE IF SCROLLING DOWN.
		if ($(document).scrollTop() >= (siteHeader.height())) {
			if (!siteHeader.hasClass('scrolled')) {
				siteHeader.addClass('scrolled');
			}
		} else {
			if (siteHeader.hasClass('scrolled')) {
				siteHeader.removeClass('scrolled');
			}
		}
	}
	
	// LISTEN FOR MENU OPEN/CLOSE
	let nav = $('#mainnav');
	
	nav.on('show.bs.collapse', function(){
		siteHeader.addClass('expanded');
	});
	
	nav.on('hide.bs.collapse', function(){
		siteHeader.removeClass('expanded');
	});
	
	$(window).resize(function () {
		ScrollShowHide();
	});
	
	$(window).scroll(function () {
		ScrollShowHide();
	});
	
	
	var pageNumber = 1;
	var postCategory = $("#load-more").data('category');
	
	function load_more_posts(categoryChange) {
		pageNumber++;
		// var querystring = '&pageNumber=' + pageNumber + '&action=load_more_post_ajax';
		
		if (categoryChange !== -1) {
			postCategory = categoryChange;
			pageNumber = 1;
			// $('.post-list').empty();
			$('#endofline').remove();
			$('#load-more').attr('disabled', false).css('display', 'block');
		}
		
		$.ajax({
			method: 'POST',
			dataType: 'html',
			url: ajax_posts.ajax_url,
			data: {
				action: 'load_more_post_ajax',
				security: ajax_posts.check_nonce,
				pageNumber: pageNumber,
				postCategory: postCategory,
			},
			beforeSend: function () {
				// Create and insert your loading message here as you desire
				// For example, a version of what you were trying to do would be:
				$("#load-more").text("LOADING ...");
			},
			// ... whatever other things you need, such as a success callback, data, url, etc
			complete: function () {
				// Remove your loading message here, for example:
				$("#load-more").text("LOAD MORE");
			},
			success: function (data) {
				var $data = $($.parseHTML(data));
				
				if ($data.length) {
					if (categoryChange !== -1) {
						$('.post-list').empty();
					}
					$('.post-list').append($data);
					
					//if ($('#endofline').length) {
					$postCount = $('.post-list--text').length;
					if ($('#endofline').data('count') == $postCount) {
						$('#load-more').attr('disabled', true);
						$('#load-more').css('display', 'none');
					} else {
						$('#load-more').attr('disabled', false);
					}
					
					jQuery(window).trigger('resize').trigger('scroll'); //RE LAYOUT THE PARALLAX EFFECT
				} else {
					$('#load-more').attr('disabled', true);
					$('#load-more').css('display', 'none');
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				$loader.html(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
			}
		});
		
		return false;
	}
	
	//LOAD MORE BUTTON PRESSED
	$('#load-more').on('click', function (e) {
		e.preventDefault();
		$(this).attr('disabled', true);
		
		load_more_posts(-1);
	});
	
	
	function filter_portfolio($filter_cat) {
		$.ajax({
			method: 'POST',
			dataType: 'html',
			url: ajax_portfolio.ajax_url,
			data: {
				action: 'filter_portfolio_ajax',
				security: ajax_portfolio.check_nonce,
				showcasecat: $filter_cat,
			},
			beforeSend: function () {
				$('#portfolio-listing').stop();
				$('#portfolio-listing').empty().addClass('showcase-loading');
			},
			complete: function () {
				$('#portfolio-listing').removeClass('showcase-loading');
			},
			success: function (data) {
				var $data = $($.parseHTML(data));
				
				// console.log(data);
				// console.log($data);
				
				if ($data.length) {
					$('#portfolio-listing').stop().empty();
					$('#portfolio-listing').append($data);
					
					jQuery(window).trigger('resize').trigger('scroll'); //RE LAYOUT THE PARALLAX EFFECT
				} else {
					// $('#load-more').attr('disabled', true);
					// $('#load-more').css('display', 'none');
				}
				$('#portfolio-listing').fadeIn(1000);
			},
			error: function (jqXHR, textStatus, errorThrown) {
				$loader.html(jqXHR + ' :: ' + textStatus + ' :: ' + errorThrown);
			}
		});
		
		return false;
	}
	
	$('#filter-bar .nav-link[href="#"]').on('click', function (e) {
		// $(this).attr('disabled', true);
		e.preventDefault();
		$('#filter-bar .nav-link').removeClass('active');
		$(this).addClass('active');
		
		var filterType = $('#filter-bar').data('type');
		if (filterType === 'portfolio') {
			filter_portfolio($(this).data('slug'));
		} else if (filterType === 'post') {
			load_more_posts($(this).data('slug'));
		}
	});
	
	if ($('#filter-bar').length > 0 && window.location.hash) {
		$('#filter-bar .nav-item a').each(function () {
			if ($(this).data('slug') === window.location.hash.substr(1, window.location.hash.length - 1)) {
				$(this).trigger('click');
			}
		});
	}

	// smooth scroll anchors
	if (location.hash) {
		if ($(location.hash).length > 0) {
			window.scrollTo(0, 0);

			$(window).on('load', function () {
				jumpTo($, $(location.hash));

				if (location.hash.indexOf('#contact-us') === 0) {
					$('a[href~="#contact-form"]').trigger('click');
				}
			});
		}
	}
	
	let $popIns = $('[data-pop]');
	$(window).on('load scroll resize', function(){
		$popIns.each(function(){
			let $this = $(this);
			let delay = 0;
			if ( $this.data('pop') !== false ) {
				delay = $this.data('pop');
			}
			if ( !$this.hasClass('popped') && $this.isInViewport() ) {
				$this.css('animation-delay',delay+'ms').addClass('popped');
			}
		});
	});
});

function jumpTo($, $target) {
	let offset = 0;
	if ($('#wpadminbar').length > 0) {
		offset -= $('#wpadminbar').outerHeight();
	}
	offset = offset - $('.site-header').outerHeight() - 20; // buffer

	$('body, html').animate({
		scrollTop: $target.offset().top + offset
	}, 2000);
}